import React from "react";


function JobsHeader() {

    return (
        <>
            <div className="pd-header">

                <div className="header-bottom">
                    <h2 className="pd-title">Work with us</h2>
                </div>
            </div>
        </>
    );
}

export default JobsHeader;
